var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgHourGlass = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 1.333v4h.007L4 5.34 6.667 8 4 10.667l.007.006H4v3.994h8v-3.994h-.007l.007-.006L9.333 8 12 5.34l-.007-.007H12v-4H4ZM10.667 11v2.333H5.333V11L8 8.333 10.667 11ZM8 7.667 5.333 5V2.667h5.334V5L8 7.667Z",
  fill: "currentColor"
})));

export default SvgHourGlass;